var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.051,
    height: 29.051,
    viewBox: "0 0 29.051 29.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_265",
    "data-name": "Raggruppa 265",
    transform: "translate(-318.5 -269.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_264",
    "data-name": "Raggruppa 264",
    transform: "translate(857 -1301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_252",
    "data-name": "Raggruppa 252",
    transform: "translate(-2497.039 1769.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(1959.539 -197.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Apert-filiale",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_149",
    "data-name": "Tracciato 149",
    d: "M20.823,18.536a3.565,3.565,0,1,1,2.71-1.332A3.706,3.706,0,0,1,21.6,18.435a3.07,3.07,0,0,1-.773.087Z",
    transform: "translate(-7.298 -1.516)",
    fill: "rgba(0,0,0,0)",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_149",
    "data-name": "Linea 149",
    x2: 5.467,
    transform: "translate(13.525 21.584) rotate(90)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_227",
    "data-name": "Linea 227",
    x2: 5.467,
    transform: "translate(13.525 0) rotate(90)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_251",
    "data-name": "Raggruppa 251",
    transform: "translate(27.051 13.525) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_228",
    "data-name": "Linea 228",
    x2: 5.467,
    transform: "translate(0 21.584) rotate(90)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_229",
    "data-name": "Linea 229",
    x2: 5.467,
    transform: "rotate(90)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1036",
    "data-name": "Tracciato 1036",
    d: "M28.086,33.061a10.975,10.975,0,1,1,8.341-4.1,11.409,11.409,0,0,1-5.96,3.789,9.45,9.45,0,0,1-2.381.267Z",
    transform: "translate(-552.061 1562.883)",
    fill: "rgba(0,0,0,0)",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.19fa58f66f7a83f1bb707d76c531daad.svg";
export { ForwardRef as ReactComponent };